import { c as _c } from "react/compiler-runtime";
export const ArrowDown = t0 => {
  const $ = _c(4);
  const {
    className,
    style
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M2.89778 0.229846C2.99462 0.0970699 3.1402 0 3.31436 0C3.48853 0 3.63411 0.0970699 3.73095 0.229846C3.82788 0.362739 3.88354 0.539465 3.88354 0.728418L3.88354 7.89036L5.52479 6.23784C5.6577 6.10402 5.82154 6.01845 5.98387 5.99342C6.14622 5.96839 6.31735 6.00366 6.44017 6.12732C6.56279 6.25079 6.59753 6.42237 6.57279 6.58496C6.54803 6.74774 6.46332 6.91243 6.3304 7.04627L3.84206 9.5517C3.72731 9.66723 3.58994 9.74644 3.45064 9.7822C3.39431 9.79875 3.33557 9.80542 3.27678 9.80368C3.23139 9.80303 3.18622 9.79722 3.14238 9.78556C2.99868 9.75143 2.85641 9.67091 2.73821 9.5519L0.249868 7.04647C0.116948 6.91264 0.0322362 6.74795 0.00747576 6.58517C-0.0172559 6.42257 0.0174818 6.25099 0.140104 6.12753C0.262921 6.00387 0.434055 5.96859 0.596397 5.99363C0.75873 6.01866 0.922572 6.10423 1.05548 6.23805L2.74519 7.93936L2.74519 0.728418C2.74519 0.539465 2.80085 0.362739 2.89778 0.229846Z" fill="currentColor" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== style) {
    t2 = <svg className={className} width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>{t1}</svg>;
    $[1] = className;
    $[2] = style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};